import React, { useEffect, useState } from 'react';
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Card,
  CardBody,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
} from 'reactstrap';
import { Box, Flex, Button, Tooltip, Tbody, Text } from '@chakra-ui/react';
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  Textarea,
} from '@chakra-ui/react';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrash, faEdit } from '@fortawesome/free-solid-svg-icons';
import { BulletList } from 'react-content-loader';
import httpInjectorService from 'services/http-injector.service';
import { toast } from 'react-toastify';
import AssignWork from './Assignworkweek';
import { Empty } from 'antd';

const CreateWorkWeek = ({
  togglePopUp,
  popUp,
  formData,
  handleChange,
  errors,
  handleSaveRule,
  savedRules,
  viewRulesCalender,
  deleteworkweek,
  renderRules,
  calendar,
  modall,
  toggle,
  daysOfWeek,
  handleClick,
  updateWorkWeek,
}) => {
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [selectedRuleId, setSelectedRuleId] = useState(null);
  const [loading, setLoading] = useState(true);

  const openDeleteModal = (ruleId) => {
    setSelectedRuleId(ruleId);
    setIsDeleteOpen(true);
  };

  const closeDeleteModal = () => {
    setSelectedRuleId(null);
    setIsDeleteOpen(false);
  };

  const confirmDelete = () => {
    if (selectedRuleId) {
      deleteworkweek(selectedRuleId);
    }
    closeDeleteModal();
  };

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  });

  return (
    <React.Fragment>
      <div>
        <Row>
          <Col md={12}>
            <Button
              colorScheme="purple"
              size="sm"
              float="right"
              rounded={2}
              onClick={togglePopUp}
            >
              <FontAwesomeIcon icon={faPlus} />
              <span className="mx-2">Create Rule</span>
            </Button>
          </Col>
        </Row>

        <Modal isOpen={isDeleteOpen} toggle={closeDeleteModal}>
          <ModalHeader toggle={closeDeleteModal}>Confirm Deletion</ModalHeader>
          <ModalBody>
            Are you sure you want to delete this Work Week Rule?
          </ModalBody>
          <ModalFooter>
            <Button
              rounded={2}
              size="sm"
              colorScheme="purple"
              onClick={closeDeleteModal}
            >
              No
            </Button>
            <Button
              rounded={2}
              size="sm"
              colorScheme="red"
              onClick={confirmDelete}
            >
              Yes
            </Button>
          </ModalFooter>
        </Modal>

        <Modal
          isOpen={popUp}
          toggle={togglePopUp}
          centered
          className="custom-modal"
        >
          <ModalHeader toggle={togglePopUp}>Create Rule</ModalHeader>

          <ModalBody style={{ padding: '24px' }}>
            {/* Rule Name */}
            <FormControl isInvalid={errors.ruleName} mb={4}>
              <FormLabel>
                Rule Name<span className="text-danger">*</span>
              </FormLabel>

              <Input
                type="text"
                name="ruleName"
                value={formData.ruleName}
                onChange={handleChange}
                placeholder="Enter rule name"
              />

              <FormErrorMessage>{errors.ruleName}</FormErrorMessage>
            </FormControl>
            {/* Description */}
            <FormControl isInvalid={errors.description}>
              <FormLabel>
                Description<span className="text-danger">*</span>
              </FormLabel>

              <Textarea
                name="description"
                value={formData.description}
                onChange={handleChange}
                placeholder="Enter description"
              />

              <FormErrorMessage>{errors.description}</FormErrorMessage>
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button
              colorScheme="purple"
              size="sm"
              style={{
                padding: '6px 18px',
                borderRadius: '6px',
              }}
              onClick={handleSaveRule}
              isDisabled={!formData.ruleName || !formData.description}
            >
              Save
            </Button>

            <Button
              colorScheme="red"
              size="sm"
              style={{
                padding: '6px 18px',
                borderRadius: '6px',
              }}
              onClick={togglePopUp}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>

        {/* {/* Display Saved Rules */}
        <Row className="g-4 mt-3">
          {savedRules.length === 0 && <Empty />}
          {savedRules.map((rule, index) => (
            <Col md={4} key={index}>
              {loading ? (
                <BulletList />
              ) : (
                <Card
                  className="shadow-sm border-0 h-100"
                  style={{
                    background: '#F6F2FF',
                    transition: 'all 0.3s ease',
                  }}
                >
                  <CardBody className="p-4">
                    {/* Rule Name */}
                    <div className="mb-3">
                      <h5 style={{ fontWeight: '600', color: '#4A2E8E' }}>
                        {rule.work_week_rule_name}
                      </h5>
                    </div>

                    {/* Description */}
                    <div className="mb-3">
                      <span style={{ fontWeight: '500', color: '#666' }}>
                        Description
                      </span>
                      <p style={{ margin: 0, fontSize: '14px', color: '#444' }}>
                        {rule.description}
                      </p>
                    </div>

                    {/* Employees */}
                    <div className="mb-4">
                      <span style={{ fontWeight: '500', color: '#666' }}>
                        Employees
                      </span>
                      <p
                        style={{
                          margin: 0,
                          fontSize: '15px',
                          fontWeight: '600',
                        }}
                      >
                        {rule.user_count}
                      </p>
                    </div>

                    {/* Buttons */}
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'end',
                        alignItems: 'center',
                        marginTop: '10px',
                      }}
                    >
                      <Button
                        colorScheme="purple"
                        rounded={2}
                        size="sm"
                        mx="2"
                        onClick={() => viewRulesCalender(rule.id)}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                        &nbsp; Update
                      </Button>

                      <Tooltip
                        label="Delete work week"
                        aria-label="Delete tooltip"
                      >
                        <Button
                          colorScheme="red"
                          rounded={2}
                          size="sm"
                          onClick={() => openDeleteModal(rule.id)}
                        >
                          <FontAwesomeIcon icon={faTrash} />
                          &nbsp; Delete
                        </Button>
                      </Tooltip>
                    </div>
                  </CardBody>
                </Card>
              )}
            </Col>
          ))}
        </Row>

        {renderRules && calendar && (
          <Modal
            isOpen={modall}
            toggle={toggle}
            style={{
              maxWidth: '1200px',
              width: '100%',
              height: '1000px',
            }}
          >
            <Row>
              <Col md={12}>
                <h2 style={{ textAlign: 'center', marginTop: '20px' }}>
                  Rules
                </h2>
              </Col>
              <Col md={12}>
                <div>
                  <Table striped style={{ width: '100%', textAlign: 'center' }}>
                    <thead>
                      <tr>
                        <th>Week No</th>
                        {daysOfWeek.map((day) => (
                          <th key={day}>{day}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {[...Array(5)].map((_, week) => (
                        <tr key={week}>
                          <td>{week + 1}</td>
                          {[...Array(7)].map((_, day) => {
                            const index = week * 7 + day;
                            const status = calendar[index]?.is_working;

                            let buttonColor;
                            if (status === 'fullday') {
                              buttonColor = 'green';
                            } else if (status === 'halfday') {
                              buttonColor = 'yellow';
                            } else {
                              buttonColor = 'red';
                            }
                            return (
                              <td
                                key={index}
                                style={{ verticalAlign: 'middle' }}
                              >
                                <button
                                  onClick={() => {
                                    handleClick(index);
                                  }}
                                  style={{
                                    width: '30px',
                                    height: '30px',
                                    display: 'block',
                                    margin: '0 auto',
                                    backgroundColor: buttonColor,
                                  }}
                                ></button>
                              </td>
                            );
                          })}
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  <Flex justify="center" align="center" mt={4}>
                    <Button
                      colorScheme="purple"
                      onClick={() => {
                        updateWorkWeek(calendar);
                        toggle();
                      }}
                      size="sm"
                      rounded={2}
                      mr={4}
                    >
                      Save
                    </Button>
                    <Button
                      size="sm"
                      rounded={2}
                      colorScheme="red"
                      onClick={() => toggle()}
                    >
                      Cancel
                    </Button>
                  </Flex>
                  <Flex
                    align="center"
                    flex="1"
                    justify="flex-start"
                    marginBottom={4}
                  >
                    <Flex align="center" marginLeft={6}>
                      <button
                        style={{
                          backgroundColor: 'green',
                          width: '16px',
                          height: '16px',
                          border: 'none',
                        }}
                      />
                      <span
                        style={{
                          marginLeft: '4px',
                          fontSize: '14px',
                          lineHeight: '16px',
                        }}
                      >
                        Working Day
                      </span>
                    </Flex>
                    <Flex align="center" marginLeft={6}>
                      <button
                        style={{
                          backgroundColor: 'yellow',
                          width: '16px',
                          height: '16px',
                          border: 'none',
                        }}
                      />
                      <span
                        style={{
                          marginLeft: '4px',
                          fontSize: '14px',
                          lineHeight: '16px',
                        }}
                      >
                        Half Day
                      </span>
                    </Flex>
                    <Flex align="center" marginLeft={6}>
                      <button
                        style={{
                          backgroundColor: 'red',
                          width: '16px',
                          height: '16px',
                          border: 'none',
                        }}
                      />
                      <span
                        style={{
                          marginLeft: '4px',
                          fontSize: '14px',
                          lineHeight: '16px',
                        }}
                      >
                        Holiday
                      </span>
                    </Flex>
                  </Flex>
                </div>
              </Col>
            </Row>
          </Modal>
        )}
      </div>
    </React.Fragment>
  );
};

export default CreateWorkWeek;
